export enum PatientSex {
  Female = 'Female',
  Male = 'Male',
  Unknown = 'Unknown',
}
